// extracted by css-extract-rspack-plugin
export default {"cls1":"UserCard-cls1_zUL","cls2":"UserCard-cls2_7Y- UserCard-cls1_zUL","truncateText":"UserCard-truncateText_WW2"};